import {
  AnalyticsFacebookDashboardOverview,
  AnalyticsFacebookDashboardAudience,
  AnalyticsFacebookDashboardFeedPosts,
  AnalyticsFacebookDashboardPostsOverview
} from '@anytag/shared-organisms';
import { useAnalyticsProfileContext } from '../../analytics-profile-context';

export const AnalyticsFacebookDashboard = () => {
  const { brandAccount, selectedSocialAccount } = useAnalyticsProfileContext();

  return (
    <>
      <AnalyticsFacebookDashboardOverview analyticsAccount={selectedSocialAccount} />
      <AnalyticsFacebookDashboardAudience analyticsAccount={selectedSocialAccount} />
      <AnalyticsFacebookDashboardPostsOverview analyticsAccount={selectedSocialAccount} />
      <AnalyticsFacebookDashboardFeedPosts
        analyticsAccount={selectedSocialAccount}
        brandAccountName={brandAccount.brandAccountName}
      />
    </>
  );
};
